import {useState} from "react"
import {createModel} from "hox"

function ShowReUpLoad() {
    const [baseStatus, setBaseStatus] = useState(false)
    const [compareStatus, setCompareStatus] = useState(false)

    const init = () => {
        setBaseStatus(false)
        setCompareStatus(false)
    }

    const toBaseTrue = () => {
        setBaseStatus(true)
    }
    const toBaseFalse = () => {
        setBaseStatus(false)
    }
    const toCompareTrue = () => {
        setCompareStatus(true)
    }
    const toCompareFalse = () => {
        setCompareStatus(false)
    }
    return {
        value: {
            Base: baseStatus,
            Compare: compareStatus,
        },
        init,
        toBaseFalse,
        toBaseTrue,
        toCompareFalse,
        toCompareTrue,
    }
}

export default createModel(ShowReUpLoad)
